import { render, staticRenderFns } from "./SabreRemarkTable.vue?vue&type=template&id=49358884"
import script from "./SabreRemarkTable.vue?vue&type=script&lang=js"
export * from "./SabreRemarkTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports